import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=3054412a&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=3054412a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054412a",
  null
  
)

export default component.exports